export const pillTransitionName = (label: string): string =>
	`pill-${label.toLowerCase().replace(/\s+/g, '-')}`;
